// extracted by mini-css-extract-plugin
module.exports = {"component":"MultipleTextInput-module__component--cAZX-","add_link_button":"MultipleTextInput-module__add_link_button--JXeW8"};